export function formatDurationMinutes(value) {
  const minutes = Number(value || 0);
  if (!minutes) {
    return "0 Min";
  }

  return `${minutes} Min`;
}

export function formatQuestionCount(value) {
  return `${Number(value || 0)} Qs`;
}

export function formatMarks(value) {
  return `${Number(value || 0)} Marks`;
}

export function mapAssessmentItem(item) {
  return {
    id: item?.assessment_id || item?.series_id || Math.random(),
    quizId: Number(item?.quiz_id || item?.assessment_id || 0),
    title: item?.name || "Untitled",
    duration: formatDurationMinutes(item?.duration),
    questions: formatQuestionCount(item?.total_questions || item?.total_quiz),
    marks: formatMarks(item?.total_marks || item?.total_free_quiz),
    attempts: Number(item?.total_attempts || 0),
    languages: item?.available_languages || "English",
    status: item?.free_paid === "F" ? "Free" : "Paid",
    description: item?.description || "",
    startDate: item?.start_date || "",
    endDate: item?.end_date || "",
    rawItem: item,
  };
}

export function mapPreviousYearItem(item) {
  return {
    id: item?.assessment_id || Math.random(),
    quizId: Number(item?.quiz_id || item?.assessment_id || 0),
    title: item?.name || "Untitled",
    duration: `${Number(item?.duration || 0)} Minutes`,
    questions: `${Number(item?.total_questions || 0)} Questions`,
    marks: `${Number(item?.total_marks || 0)} Marks`,
    attempts: Number(item?.total_attempts || 0),
    languages: item?.available_languages || "English",
    rawItem: item,
  };
}
